import React from "react";
import Plot from 'react-plotly.js';

function TraitLocAndYearsPlot(props) {
    if (props.data === null) {
        return (
            <div className="card my-3 mx-3">
                <div className="card-body d-flex align-items-center justify-content-center">
                    Failed to create visualization
                </div>
            </div>
        )
    }
    else {
        const plotDict = {};
        props.data.forEach(record => {
            if (record[props.trait]) {
                if (plotDict[record.YEAR] === undefined) {
                    plotDict[record.YEAR] = {
                        y: [],
                        x: [],
                        name: record.YEAR,
                        type: 'box'
                    }
                }
                plotDict[record.YEAR].y.push(record[props.trait]);
                plotDict[record.YEAR].x.push(record.LOC);
            }
        });
        const plotData = Object.values(plotDict);

        return (
            <Plot
                data={plotData}
                layout={{ boxmode: 'group', title: `Distribution of ${props.trait} Across Locations and Years`, xaxis: { title: 'Location' }, yaxis: { title: `${props.trait}` }, width: props.width, height: props.height }}
            />
        )
    }
}

export default TraitLocAndYearsPlot;